import { render, staticRenderFns } from "./menu-quarternary.vue?vue&type=template&id=2280f2fe&scoped=true&"
import script from "./menu-quarternary.vue?vue&type=script&lang=js&"
export * from "./menu-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280f2fe",
  null
  
)

export default component.exports